export function getFirebaseErrorMessage(error: any): string {
  // Check if it's a Firebase error
  if (error?.response?.data?.message?.includes('Firebase:')) {
    const firebaseMessage = error.response.data.message
    
    // Extract the Firebase error code
    const firebaseErrorMatch = firebaseMessage.match(/Firebase: Error \(([^)]+)\)/)
    if (firebaseErrorMatch) {
      const errorCode = firebaseErrorMatch[1]
      return getFirebaseErrorByCode(errorCode)
    }
  }
  
  // Check if it's a direct Firebase error object
  if (error?.code && error?.message?.includes('Firebase:')) {
    return getFirebaseErrorByCode(error.code)
  }
  
  // Check if it's an Axios error with Firebase message
  if (error?.message?.includes('Firebase:')) {
    const firebaseErrorMatch = error.message.match(/Firebase: Error \(([^)]+)\)/)
    if (firebaseErrorMatch) {
      const errorCode = firebaseErrorMatch[1]
      return getFirebaseErrorByCode(errorCode)
    }
  }
  
  // Default error message
  return 'Authentication failed. Please check your credentials and try again.'
}

function getFirebaseErrorByCode(errorCode: string): string {
  const errorMessages: Record<string, string> = {
    'auth/invalid-credential': 'Invalid email or password.',
    'auth/user-not-found': 'No account found with this email address.',
    'auth/wrong-password': 'Incorrect password. Please try again.',
    'auth/invalid-email': 'Please enter a valid email address.',
    'auth/too-many-requests': 'Too many failed login attempts.',
    'auth/network-request-failed': 'Network error.',
    'auth/user-disabled': 'This account has been disabled.'
  }
  
  return errorMessages[errorCode] || 'Authentication failed.'
} 